import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ContactMainType,
} from 'app/enums/label.enums'
import {
    ColumnConfigMappingType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

type ContactTable = Contact & {
    locationLocationName: string,
    locationCompanyCompanyName: string
}

const locationField: ColumnConfigMappingType<ContactTable>[] = [{
    name: 'locationLocationName',
    filterField: 'locationLocationName',
    labelKey: 'Contact.location',
}]
const basicFields: ColumnConfigMappingType<ContactTable>[] = [
    {
        name: 'contactName',
        filterField: 'contactName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'Contact.contactName',
    },
    {
        name: 'email',
        filterField: 'email',
        filterType: FilterType.Array,
        labelKey: 'Contact.email',
    },
    {
        name: 'phone',
        filterField: 'phone',
        filterType: FilterType.Array,
        labelKey: 'Contact.phone',
    },
    {
        name: 'isMainContact',
        componentName: 'ChipCheckMark',
        labelKey: 'Contact.isMainContact',
    },
    {
        name: 'countryCountryName',
        labelKey: 'Country.basedInCountry',
    },
]

const restFields: ColumnConfigMappingType<ContactTable>[] = [
    {
        name: 'mainType',
        componentName: 'EnumList',
        allowedValuesEnum: ContactMainType,
        labelKey: 'Contact.mainType',
    },
    {
        name: 'createdOn',
        labelKey: 'Accounts.createdOn',
    },
    {
        name: 'createdBy',
        filterField: 'createdBy',
        filterType: FilterType.Array,
        labelKey: 'AccountQuotes.createdBy',
    },
]

const config = [
    ...basicFields,
    ...locationField,
    ...[{
        name: 'locationCompanyCompanyName',
        filterField: 'locationCompanyCompanyName',
        reduced: true,
        labelKey: 'Location.company',
    }] as SkyNetTableField<keyof ContactTable>[],
    ...restFields,
] as ColumnConfigMappingType<ContactTable>[]

export default config
